import { batchChange, change } from "./actions";

/**
 * Creates a batch of Redux changes that can be committed in a single dispatch.
 * Use this to reduce multiple `change()` calls into one atomic update.
 *
 * @param {function} dispatch - Redux dispatch function
 * @returns {{ queue: (path: string, value: any) => void, commit: () => void }}
 */
export function createChangeBatch(dispatch) {
    const changes = [];

    return {
        /**
         * Add a path/value change to the batch (does not dispatch yet)
         */
        queue(path, value) {
            changes.push({ path, value });
        },

        /**
         * Dispatch all queued changes as a single action.
         * Falls back to regular CHANGE for single-item batches.
         */
        commit() {
            if (changes.length === 0) {
                return;
            }

            if (changes.length === 1) {
                const [{ path, value }] = changes;
                dispatch(change(path, value));
                return;
            }

            dispatch(batchChange(changes));
        },
    };
}
